import { initializeApp, getApps } from "firebase/app"
import firebaseConfig from "./firebase.config"

const inititializeAuthentication = () => {
   if (!getApps().length) {
      initializeApp(firebaseConfig)
   }
}

export default inititializeAuthentication
